import type { useTranscodeProgressFragment } from '../../shared/gql/generated/TranscodeProgress';
import type { AssetState } from '../types';

export function getStateForFirefly(
  transcodesFragment: ReturnType<typeof useTranscodeProgressFragment>
): AssetState | undefined {
  /** If the asset is transcoded or uploaded, we don't need to worry about the firefly generation state */
  if (
    transcodesFragment?.data?.status === 'TRANSCODED' ||
    transcodesFragment?.data?.status === 'UPLOADED'
  ) {
    return undefined;
  }

  if (transcodesFragment?.data?.__typename === 'FolderAsset') return undefined;

  if (
    transcodesFragment?.data?.fireflyGeneration?.overallStatus === 'IN_PROGRESS'
  ) {
    return 'firefly-generating';
  }

  if (transcodesFragment?.data?.fireflyGeneration?.overallStatus === 'FAILED') {
    return 'firefly-error';
  }

  return undefined;
}
